import React from 'react';

// Import all doc section components
import Overview from './Overview';
import Quickstart from './Quickstart';
import MemoryApiGuide from './MemoryApiGuide';
import MemoryApiGuideJavaScript from './MemoryApiGuideJavaScript';
import FAQ from './FAQ';
import CloudVersion from './CloudVersion';
import EnterpriseEdition from './EnterpriseEdition';
import SelfHosting from './SelfHosting';
import UseCases from './UseCases';
import Contributing from './Contributing';
import MemoryTypes from './MemoryTypes';
import MemoryOperations from './MemoryOperations';
import AddMemory from './AddMemory';
import RetrieveMemory from './RetrieveMemory';
import MemoryApis from './MemoryApis';
import ResponseAPIs from './ResponseAPIs';
import MemorizeConversation from './MemorizeConversation';
import GetTaskStatus from "./GetTaskStatus";
import ResponseAPIGuidePython from "./ResponseAPIGuidePython";
import ResponseAPIGuideJavaScript from "./ResponseAPIGuideJavaScript";
import RetrieveDefaultCategories from "./RetrieveDefaultCategories";
import RetrieveRelatedMemoryItems from "./RetrieveRelatedMemoryItems";
import RetrieveRelatedClusteredCategories from "./RetrieveRelatedClusteredCategories";
import DeleteMemories from "./DeleteMemories";
import Chat from "./Chat";
import MemuVsMem0 from "./MemuVsMem0";

const ContentRenderer = ({ activeSection, onSectionChange }) => {
  const componentMap = {
    'overview': Overview,
    'quickstart': Quickstart,
    'responseapi': ResponseAPIGuidePython,
    'response-api-js': ResponseAPIGuideJavaScript,
    'chat': Chat,
    'memory': MemoryApiGuide,
    'memory-api-js': MemoryApiGuideJavaScript,
    'memory-apis': MemoryApis,
    'response-apis': ResponseAPIs,
    'faq': FAQ,
    'cloud-version': CloudVersion,
    'enterprise-edition': EnterpriseEdition,
    'self-hosting': SelfHosting,
    'use-cases': UseCases,
    'memory-types': MemoryTypes,
    'memory-operations': MemoryOperations,
    'add-memory': AddMemory,
    'retrieve-memory': RetrieveMemory,
    'memorize-conversation': MemorizeConversation,
    'get-task-status': GetTaskStatus,
    'retrieve-default-categories': RetrieveDefaultCategories,
    'retrieve-related-memory-items': RetrieveRelatedMemoryItems,
    'retrieve-related-clustered-categories': RetrieveRelatedClusteredCategories,
    'delete-memories': DeleteMemories,
    'contributing': Contributing,
    'memu-vs-mem0': MemuVsMem0
  };

  const ComponentToRender = componentMap[activeSection];

  if (!ComponentToRender) {
    return <div className="doc-content">Content not found</div>;
  }

  return <ComponentToRender onSectionChange={onSectionChange} />;
};

export default ContentRenderer;